/* istanbul ignore file */
import * as pbi from "powerbi-client";

export default {
  install(app) {
    app.config.globalProperties.$powerBi = pbi;
  },
};
